import useBenchmarksTableViewModel from './BenchmarksTableViewModel'
import dayjs from 'dayjs'
import cn from 'clsx'
import IndeterminateLoadingBar from '@components/shared/IndeterminateLoadingBar'
import Checkbox from '$components/Forms/Checkbox'
import { BsSortDown, BsSortUp } from 'react-icons/bs'
import { MdDeleteSweep, MdDelete } from 'react-icons/md'

const BenchmarksTable = () => {
    
    const vm = useBenchmarksTableViewModel()
    
    if (vm.benchmarksError) return console.error(vm.benchmarksError) || (
        <div className="BenchmarksTable flex flex-col justify-center items-center gap-4">
            <div className="text-center">
                <p>Failed to fetch benchmarks</p>
                <div><pre><code>{JSON.stringify(vm.benchmarksError, null, 4)}</code></pre></div>
            </div>
        </div>
    )
    
    return (<>
        
        <IndeterminateLoadingBar
            className="!h-1 rounded"
            isLoading={vm.benchmarksIsLoading}
            colorClass="bg-base-200/50"
            altColorClass="bg-base-300/50" />
        
        <table className="BenchmarksTable table-auto table-sm table-sticky-headers">
            
            <thead>
                <tr>
                    <th>
                        <Checkbox
                            checked={vm.allChecked}
                            indeterminate={vm.someChecked}
                            onChange={vm.toggleAllChecked} />
                    </th>
                    <th>User</th>
                    <th>Organization</th>
                    <th>Date</th>
                    <th>
                        <div
                            className={cn('cursor-pointer', {
                                'text-accent': vm.searchParams.get('orderBy') === 'topic',
                            })}
                            onClick={() => vm.updateSort('topic')}>
                            <span>Topic</span>
                            {vm.searchParams.get('orderDirection') === 'asc' ? <BsSortDown /> : <BsSortUp />}
                        </div>
                    </th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Diff</th>
                    <th>
                        <div
                            className={cn('cursor-pointer', {
                                'text-accent': vm.searchParams.get('orderBy') === 'seconds',
                            })}
                            onClick={() => vm.updateSort('seconds')}>
                            <span>Seconds</span>
                            {vm.searchParams.get('orderDirection') === 'asc' ? <BsSortDown /> : <BsSortUp />}
                        </div>
                    </th>
                    <th>Milliseconds</th>
                    <th>
                        <div className="flex justify-center items-center content-center gap-2">
                            <button
                                className="btn btn-sm btn-square btn-error"
                                disabled={!vm.anyChecked}
                                onClick={vm.onDeleteCheckedClick}>
                                <MdDeleteSweep className="!ml-0" />
                            </button>
                        </div>
                    </th>
                </tr>
            </thead>
            
            <tbody>
                {vm.benchmarks?.map(it => (
                    <tr key={`BenchmarksTable-benchmark-${it.id}`}>
                        <td>
                            <Checkbox
                                checked={vm.hasChecked(it.id)}
                                onChange={() => vm.toggleChecked(it.id)} />
                        </td>
                        <td>{it.createdBy?.email ?? 'N/A'}</td>
                        <td>{it.organization?.name ?? 'N/A'}</td>
                        <td>{dayjs(it.updatedAt).format('MMM DD [at] hh:mm A')}</td>
                        <td>{it.topic}</td>
                        <td>{it.start}</td>
                        <td>{it.end}</td>
                        <td>{it.diff}</td>
                        <td>{it.seconds}</td>
                        <td>{it.milliseconds}</td>
                        <td>
                            <div className="flex justify-center items-center content-center gap-2">
                                <button
                                    className="btn btn-sm btn-square btn-ghost group"
                                    onClick={() => vm.onDeleteClick(it.id)}>
                                    <MdDelete className="text-error/30 group-hover:text-error" />
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        
        </table>
    
    </>)
    
}

export default BenchmarksTable
